/**
 * @generated SignedSource<<52d19093458fe604e2f734afd08b508a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment$data = {
  readonly id: string;
  readonly " $fragmentType": "editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment";
};
export type editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment$key = {
  readonly " $data"?: editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editWrongAnswerInMatrixElementCellForm_AnswerMatrixElementCellFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "AnswerMatrixElementCell",
  "abstractKey": null
};

(node as any).hash = "2268b630e7ec51993f0a60e73aea860f";

export default node;
